class AdminController {
  constructor(AuthenticationService, $rootScope, $state, $location, $scope) {
    "ngInject";
    this.authenticationService = AuthenticationService;
    this.name = 'admin';
    this.rootScope = $rootScope;
    this.loaded = false;
    this.state = $state;
    let self = this;

   }

   userLoaded() {
      return (this.authenticationService.user !== undefined);
   }


}

export default AdminController;



// WEBPACK FOOTER //
// ./client/pages/admin/admin.controller.js